export const Logo = ({ size = 34, showText = true, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
    <img
      src="/logo.png"
      alt="AGARWAL360 logo"
      style={{ width: size, height: size }}
      className="shrink-0 object-contain"
    />
    {showText && (
      <span className="font-head text-base font-extrabold tracking-tighter leading-none">
        AGARWAL<span className="text-[#C8A03C]">360</span>
      </span>
    )}
  </div>
);
